const BASE_URL = "https://www.palmettoparking.com";

export default BASE_URL;
